import { excludedLanguageFromUrl, languages } from '@valk-nx/core/lib/core';

export class DocumentLangHelper {
	static setFromUrl(windowLocation: string | undefined): void {
		if (!windowLocation) {
			return;
		}
		const seg = windowLocation.split('/')[1];
		document.documentElement.lang = (
			languages as readonly string[]
		).includes(seg)
			? seg
			: excludedLanguageFromUrl;
	}
}
